import React from 'react';

import { useI18n } from 'lib/i18n/context';

import ContractVerificationMethod from '../ContractVerificationMethod';
import ContractVerificationFieldCompiler from '../fields/ContractVerificationFieldCompiler';
import ContractVerificationFieldSources from '../fields/ContractVerificationFieldSources';
import { CONTRACT_VERIFICATION_FIELD_KEYS, CONTRACT_VERIFICATION_METHOD_TITLE_KEYS } from '../i18n';

const FILE_TYPES = [ '.json' as const ];

const ContractVerificationVyperStandardInput = () => {
  const { t } = useI18n();
  return (
    <ContractVerificationMethod title={ t(CONTRACT_VERIFICATION_METHOD_TITLE_KEYS['vyper-standard-input']) }>
      <ContractVerificationFieldCompiler isVyper/>
      <ContractVerificationFieldSources
        fileTypes={ FILE_TYPES }
        title={ t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.standardInputJsonTitle) }
        hint={ t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.standardInputJsonHint) }
        required
      />
    </ContractVerificationMethod>
  );
};

export default React.memo(ContractVerificationVyperStandardInput);
